import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import News from './pages/News';
import Contact from './pages/Contact';
import CourseCatalog from './pages/CourseCatalog';
import StaffProfile from './pages/StaffProfile';
import StaffDashboard from './pages/StaffDashboard';
import EventsPage from './pages/EventsPage';
import ResearchPage from './pages/ResearchPage';
import AwardsPage from './pages/AwardsPage';
import AdminPage from './pages/AdminPage';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
              <Route path="/CourseCatalog" element={<CourseCatalog />} />
              <Route path="/StaffProfile" element={<StaffProfile/>} />
            <Route path="/StaffDashboard" element={<StaffDashboard />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/research" element={<ResearchPage />} /> 
            <Route path="/AwardsPage" element={<AwardsPage />} /> 
            <Route path="/AdminPage" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;